import RichTextEditorField from "components/Reusable/Form/RichTextEditorField.js";

const fields = {
  userEmail: {
    fieldKey: "userEmail",
    element: "input",
    type: "email",
    title: "userEmail",
    placeholder: "login-user-email-placeholder",
    label: "login-user-email-label",
    disabled: true,
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  },
  userMessage: {
    element: "customelement",
    fieldKey: "userMessage",
    validation: {
      maxLength: 2000,
    },
    render: (props) => (
      <RichTextEditorField {...props} alwaysShowTools={true} />
    ),
  },
};

export default fields;
